import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AlertModule, ElementSize, SharedDirectivesModule } from 'mbs-ui-kit';
import { PageHeaderComponent } from 'mbs-ui-shared@components/page-header/page-header.component';
import { SomethingWentWrongComponent } from 'mbs-ui-shared@components/something-went-wrong/something-went-wrong.component';
import { DirectivesModule } from '../../directives/directives.module';

@UntilDestroy()
@Component({
  selector: 'page-layout',
  templateUrl: './page-layout.component.html',
  standalone: true,
  styleUrls: ['page-layout.component.scss'],
  imports: [CommonModule, DirectivesModule, SharedDirectivesModule, AlertModule, PageHeaderComponent, SomethingWentWrongComponent]
})
export class PageLayoutComponent {
  @Input() pageClass = '';
  @Input() contentClass = '';
  @Input() showErrorPage = false;

  @Output() sizeChanged = new EventEmitter<ElementSize>();
  @Output() refresh = new EventEmitter<void>();

  public headerSize: ElementSize;

  public setHeaderSize(size: ElementSize) {
    this.headerSize = size;
    this.sizeChanged.emit(size);
  }
}
